import { AppState } from '../index';

export const isRailOpenSelector = ({ rail }: AppState): boolean => rail?.railOpen || false;
